export const declarationStatuses = {
  PRECALCULATED: 'À déclarer', DRAFT: 'Brouillon', PENDING_APPROVAL: 'Second approbateur requis',
  SUBMITTED: 'Soumise', VALIDATED: 'Validée', REJECTED: 'Rejetée',
};
export const reviewResults = {
  validated: ['Validée sans anomalie ouverte', 'good'],
  anomaly: ['Anomalie à examiner', 'danger'],
  review: ['À vérifier', 'warning'],
  neutral: ['Information', 'neutral'],
};
export const activities = {ACCOMMODATION: 'Hébergement', RESTAURANT: 'Restauration', EXTRAS: 'Services annexes', OTHER: 'Autre activité'};
export const monthEndAmount = (n, currency) => n == null ? 'Non renseigné' : `${Number(n).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 4})} ${currency}`;
export const monthEndPercentage = (n, d) => Number(d) > 0 ? `${(100 * Number(n || 0) / Number(d)).toLocaleString('fr-FR', {maximumFractionDigits: 2})} %` : '—';

export const declarationTones = {PRECALCULATED:'warning',DRAFT:'neutral',PENDING_APPROVAL:'warning',SUBMITTED:'warning',VALIDATED:'good',REJECTED:'danger'};
export const caseStatuses = {OPEN:'Ouvert',ASSIGNED:'Affecté',UNDER_REVIEW:'En examen',CLOSED:'Clôturé'};
export const riskLabels = {LOW:'Faible',MEDIUM:'Moyen',HIGH:'Élevé',CRITICAL:'Très élevé'};
